declare global {
	interface Window {
		dataLayer: Record<string, any>[]
	}
}

/**
 * @example
 * https://developers.google.com/analytics/devguides/collection/gtagjs/events
 */
export const event = ({
	action,
	data = {},
}: {
	action: string
	data?: Record<string, unknown>
}) => {
	if (!window.dataLayer) {
		console.warn(
			"window.dataLayer is not defined. This could mean your google analytics script has not loaded on the page yet.",
		)
		return
	}
	window.dataLayer.push({ event: action, ...data })
}
